/* const APIBASE = 'https://demoapi.bdagpo.com/api/';
const IMAGEURL = 'https://demomedia.bdagpo.com/'; */

const APIBASE = 'https://api.bdagpo.com/api/';
 const IMAGEURL = 'https://media.bdagpo.com/';

export { APIBASE, IMAGEURL };